import { ITextPresentableObject } from "../../../../../../domain/editableFormat/objects";
import { ITextPresentableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { RectangleCoordinatableObjectTranslator } from "./RectangleCoordinatableObjectTranslator";

export class TextPresentableObjectTranslator<TObject extends ITextPresentableObject, TBean extends ITextPresentableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new RectangleCoordinatableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.text = bean["@text"];
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@text"] = object.text;
  }
}
